import {$, w} from './constants';

if ($('.show_pdf_pop').length) {
    viewerLegal();
}

if ($('#search_legal_documents').length) {
    searchLegalDocuments();
}

function viewerLegal() {
    $(document).on('click', '.show_pdf_pop', function (e) {
        e.preventDefault();

        const pdfUrl = $(this).data('pdf-url');

        if (!pdfUrl) return;

        $('#viewer_url_legal').attr('src', pdfUrl);

        $('#viewer_legal').fadeIn(300);

        $('body').addClass('overflow-hidden');
    });

    $(document).on('click', '#close_viewer_legal', function () {
        $('#viewer_legal').fadeOut(300, function () {
            $('#viewer_url_legal').attr('src', '');
        });

        $('body').removeClass('overflow-hidden');
    });
}

function searchLegalDocuments() {
    const $form = $('#search_legal_documents');
    const $input = $('#search_documents_legal');
    const $items = $('.legal-template__layout-block-item');
    const $blocks = $('.legal-template__layout-block');

    $form.on('submit', function (e) {
        e.preventDefault();
        filterLegalDocuments();
    });

    $input.on('input', function () {
        filterLegalDocuments();
    });

    function filterLegalDocuments() {
        const query = normalizeText($input.val());

        $('.legal-template__layout-no-results').remove();
        
        if (query.length <= 3) {
            $items.show();
            $blocks.show();
            return;
        }

        let totalVisible = 0;

        $items.each(function () {
            const $item = $(this);
            const searchText = normalizeText($item.data('search') || '');

            const isMatch = searchText.includes(query);

            $item.toggle(isMatch);

            if (isMatch) {
                totalVisible++;
            }
        });

        $blocks.each(function () {
            const $block = $(this);
            const hasVisibleItems = $block.find('.legal-template__layout-block-item:visible').length > 0;

            $block.toggle(hasVisibleItems);
        });

        if (totalVisible === 0) {
            $('.legal-template__layout-wrapper').append(`
                <div class="legal-template__layout-no-results">
                    <p class="txt-21">No encontramos documentos relacionados con tu búsqueda.</p>
                </div>
            `);
        }
    }

    function renderNoResults(totalVisible) {
        $('.legal-template__layout-no-results').remove();

        if (totalVisible > 0) return;

        $('.legal-template__layout-wrapper').append(`
            <div class="legal-template__layout-no-results">
                <p class="txt-21">No encontramos documentos relacionados con tu búsqueda.</p>
            </div>
        `);
    }
}

function normalizeText(text) {
    return String(text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[.\-,]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}